import React from 'react';
import styled from '@emotion/styled';
import { RichText as PrismicRichText, RichTextProps } from 'prismic-reactjs';

const StyledRich = styled.div`
  & > * {
    margin: inherit;
    padding: inherit;
    line-height: inherit;
    font-family: inherit;
    font-size: inherit;
    font-weight: inherit;
  }
`;

const RichText: React.FC<RichTextProps & { className?: string; as?: React.ElementType }> = ({
  className,
  as,
  render,
}) => (
  <StyledRich className={className} as={as}>
    <PrismicRichText render={render} />
  </StyledRich>
);

export default RichText;
